<template>
  <div class="slide-item">
    <div class="content">
      <div class="left">
        <img class="logo" :src="logoSrc" alt="Crystal logo" />
        <div class="title">
          <div class="accent">1000 Мбіт/с виконають</div>
          усі ваші бажання
        </div>
        <app-btn class="btn btn-pink btn-sm">Підключити</app-btn>
      </div>
    </div>
  </div>
</template>

<script>
import AppBtn from "@/components/common/ui/AppBtn.vue";
import logoSrc from "@/assets/logo.svg";

export default {
  name: "SlideItem",
  components: {
    AppBtn,
  },
  setup() {
    return {
      logoSrc,
    };
  },
};
</script>

<style scoped lang="less">
@import "@/styles/_variables.less";

.slide-item {
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("@/assets/home/slider/main-banner.jpg") no-repeat center
    center;
  background-size: cover;
  aspect-ratio: 350/180;
  width: 1320px;
  max-width: 100%;
  border-radius: 15px;

  .content {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;

    .left {
      width: 50%;
      padding: 20px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      @media @md {
        padding: 30px;
      }

      @media @lg {
        padding: 20px;
      }

      @media @xl {
        padding: 30px;
      }

      .logo {
        width: 70%;
        height: auto;
        margin-bottom: 14px;

        @media @md {
          margin-bottom: 20px;
        }

        @media @lg {
          margin-bottom: 14px;
        }

        @media @xl {
          margin-bottom: 20px;
        }
      }

      .title {
        text-transform: uppercase;
        font-style: normal;
        font-weight: 900;
        font-size: 14px;
        line-height: 18px;
        color: @white;
        margin-bottom: 15px;

        @media @md {
          font-size: 18px;
          line-height: 22px;
          margin-bottom: 28px;
        }

        @media @lg {
          font-size: 14px;
          line-height: 18px;
          margin-bottom: 21px;
        }

        @media @xl {
          font-size: 18px;
          line-height: 22px;
          margin-bottom: 28px;
        }

        .accent {
          font-style: normal;
          font-weight: 900;
          font-size: 24px;
          line-height: 26px;
          margin-bottom: 2px;

          @media @md {
            font-size: 36px;
            line-height: 40px;
            margin-bottom: 4px;
          }

          @media @lg {
            font-size: 24px;
            line-height: 26px;
            margin-bottom: 2px;
          }

          @media @xl {
            font-size: 36px;
            line-height: 40px;
            margin-bottom: 4px;
          }
        }
      }
    }
  }
}
</style>
